export default __webpack_public_path__ + "static/media/to-message.5fa72533.svg";